import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function VendorRFQPage() {
  const { rfqId, vendorId } = useParams();
  const [rfq, setRfq] = useState(null);
  const [rates, setRates] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [gstTypes, setGstTypes] = useState({});
  const [attachments, setAttachments] = useState({});

  const API_BASE = process.env.REACT_APP_API_URL || "https://fabulous-blessing-production.up.railway.app";

  useEffect(() => {
    fetch(`${API_BASE}/vendor-rfq/${rfqId}/${vendorId}`)
      .then((res) => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then((data) => {
        const loadedRfq = data.items ? data : { items: data };
        setRfq(loadedRfq);

        // Reopen with the vendor's latest saved quotation instead of blank
        // inputs. A zero-rate submission remains editable on the next visit.
        const savedRates = {};
        const savedGstTypes = {};
        (loadedRfq.items || []).forEach((item) => {
          const itemId = item.item_id || item.id;
          if (item.quotation_rate !== null && item.quotation_rate !== undefined) {
            savedRates[itemId] = String(item.quotation_rate);
          }
          if (item.quotation_gst_type) {
            savedGstTypes[itemId] = item.quotation_gst_type;
          }
        });
        setRates(savedRates);
        setGstTypes(savedGstTypes);
        setLoading(false);
      })
      .catch(() => {
        setError("Unable to retrieve project data. Please verify the URL or try again later.");
        setLoading(false);
      });
  }, [rfqId, vendorId, API_BASE]);

  const updateRate = (id, val) => setRates((p) => ({ ...p, [id]: val }));
  const updateGST = (id, val) =>
    setGstTypes((p) => ({ ...p, [id]: val }));

  const updateAttachment = (id, file) =>
    setAttachments((p) => ({ ...p, [id]: file }));

  const handleSubmit = async () => {
  try {
    setIsSubmitting(true);

    const formData = new FormData();

    formData.append("rfq_id", rfqId);
    formData.append("vendor_id", vendorId);

    const quotations = (rfq?.items || []).map((item) => {

      const id = item.item_id || item.id;

      return {
        item_id: id,
        rate: parseFloat(rates[id]) || 0,
        gst_type: gstTypes[id] || "Without GST"
      };
    });
    formData.append(
      "quotations",
      JSON.stringify(quotations)
    );

    Object.keys(attachments).forEach((id) => {

      if (attachments[id]) {

        formData.append(
          `attachment_${id}`,
          attachments[id]
        );

      }

    });

    const response = await fetch(
      `${API_BASE}/submit-quotation`,
      {
        method: "POST",
        body: formData
      }
    );

    const data = await response.json();

    if (!response.ok)
      throw new Error(data.error);

    alert("Quotation submitted successfully ✅");

  } catch (err) {

    console.log(err);

    alert(err.message);

  } finally {

    setIsSubmitting(false);

  }
};

  if (loading) return <div style={centerStyle}><div style={spinnerStyle}></div>Loading Portal...</div>;
  if (error) return <div style={centerStyle}><div style={errorCardStyle}>{error}</div></div>;

const subTotal = (rfq?.items || []).reduce((total, item) => {
  const id = item.item_id || item.id;
  return total + (Number(item.quantity || 0) * Number(rates[id] || 0));
}, 0);

const getGstRate = (id) => Number.parseFloat(gstTypes[id]) || 0;

const gstTotal = (rfq?.items || []).reduce((total, item) => {
  const id = item.item_id || item.id;
  const amount = Number(item.quantity || 0) * Number(rates[id] || 0);
  return total + (amount * getGstRate(id)) / 100;
}, 0);

const grandTotal = subTotal + gstTotal;


  return (
    <div style={containerStyle}>
      <div style={cardWrapperStyle}>
        {/* HEADER WITH LOGO */}
        <div style={headerStyle}>
          <img
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="Ensileta"
            style={{
              height: "40px",
              marginBottom: "16px",
              objectFit: "contain"
            }}
          />
          <div>
            <h1 style={{ margin: 0, fontSize: "26px", fontWeight: 700, color: "#0f172a" }}>
              Request For Quotation
            </h1>
            <p style={{ marginTop: "6px", margin: 0, color: "#64748b", fontSize: "14px", fontWeight: 500 }}>
              RFQ Reference: <span style={{ color: "#0f172a", fontWeight: 600 }}>#{rfqId}</span>
            </p>
          </div>
        </div>
          {/* ==========================================
                     PROJECT REFERENCE DOCUMENTS
              ========================================== */}

{rfq?.referenceFiles?.length > 0 && (

<div
style={{
    background:"#fff",
    border:"1px solid #E2E8F0",
    borderRadius:12,
    padding:20,
    marginBottom:25
}}
>

<h3
style={{
    marginTop:0,
    marginBottom:15,
    color:"#0F172A"
}}
>
📎 Project Reference Documents
</h3>

{

rfq.referenceFiles.map((doc,index)=>(

<div

key={index}

style={{

display:"flex",

justifyContent:"space-between",

alignItems:"center",

padding:"12px 0",

borderBottom:
index===rfq.referenceFiles.length-1
?"none"
:"1px solid #E2E8F0"

}}

>

<div>

<div
style={{
fontWeight:600
}}
>
📄 {doc.file_name}
</div>

<div
style={{
fontSize:12,
color:"#64748B"
}}
>
{doc.file_type}
</div>

</div>

<div
style={{
display:"flex",
gap:12
}}
>

<a

href={doc.file_path}

target="_blank"

rel="noreferrer"

style={{

textDecoration:"none",

color:"#2563EB",

fontWeight:600

}}

>

View

</a>

<a

href={doc.file_path}

download

style={{

textDecoration:"none",

color:"#16A34A",

fontWeight:600

}}

>

Download

</a>

</div>

</div>

))

}

</div>

)}

        {/* PROCUREMENT TABLE */}
        <div style={tableContainerStyle}>
          <table style={tableStyle}>
            <thead>
  <tr style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
  <th style={{ ...thStyle, minWidth: "220px" }}>Item Name</th>
  <th style={thStyle}>UOM</th>
  <th style={thStyle}>Qty</th>
  <th style={{ ...thStyle, minWidth: "150px" }}>Rate</th>
  <th style={thStyle}>GST</th>
  <th style={{ ...thStyle, minWidth: "130px" }}>Amount</th>
  <th style={{ ...thStyle, minWidth: "130px" }}>GST Amount</th>
  <th style={{ ...thStyle, minWidth: "140px" }}>Total Amount</th>
  <th style={{ ...thStyle, minWidth: "180px" }}>Vendor Attachment</th>
</tr>
</thead>
            <tbody>
  {(rfq?.items || []).map((item) => {
    const id = item.item_id || item.id;
    const qty = Number(item.quantity || 0);
    const rate = Number(rates[id] || 0);
    const amount = qty * rate;
    const gstAmount = (amount * getGstRate(id)) / 100;
    const totalAmount = amount + gstAmount;

    return (
      <tr key={id} style={{ borderBottom: "1px solid #e5e7eb" }}>

        <td style={{ ...tdStyle, ...itemNameCellStyle }}>
          {item.item_name}
        </td>

        {/* UOM */}
        <td style={tdStyle}>
          {item.uom}
        </td>

        {/* Qty */}
        <td style={tdStyle}>
          {item.quantity}
        </td>

        {/* Base Rate */}
        {/* Base Rate */}
<td style={{ ...tdStyle, minWidth: "150px" }}>
  <input
    type="number"
    min="0"
    step="any"
    placeholder="Enter rate"
    value={rates[id] || ""}
    onChange={(e) => updateRate(id, e.target.value)}
    style={{ ...inputStyle, textAlign: "right" }}
  />
</td>

        {/* GST */}
        <td style={tdStyle}>
          <select
            value={gstTypes[id] || "Without GST"}
            onChange={(e) => updateGST(id, e.target.value)}
            style={inputStyle}
          >
            <option>Without GST</option>
            <option>18%</option>
            <option>12%</option>
            <option>5%</option>
            <option>0%</option>
          </select>
        </td>

        <td style={{ fontWeight: 700 }}>
  ₹ {amount.toFixed(2)}
</td>

        
        <td style={{ ...tdStyle, ...amountCellStyle }}>GST: {gstAmount.toFixed(2)}</td>
        <td style={{ ...tdStyle, ...amountCellStyle }}>Total: {totalAmount.toFixed(2)}</td>

        {/* Vendor Attachment */}
<td style={{ ...tdStyle, minWidth: "180px" }}>
  <label style={fileInputLabelStyle}>
    {attachments[id] ? "Change file" : "Upload file"}
    <input
      type="file"
      hidden
      accept=".pdf,.jpg,.jpeg,.png,.dwg,.dxf,.xls,.xlsx"
      onChange={(e) => updateAttachment(id, e.target.files[0])}
    />
  </label>
  {attachments[id] && (
    <div style={attachmentNameStyle} title={attachments[id].name}>
      ✔ {attachments[id].name}
    </div>
  )}
</td>
      </tr>
    );
  })}
</tbody>
          </table>
</div>

<div
style={{
    width:320,
    marginLeft:"auto",
    marginTop:20,
    marginBottom:20,
    border:"1px solid #ddd",
    borderRadius:10,
    padding:20,
    background:"#fff"
}}
>

<div style={{display:"flex",justifyContent:"space-between"}}>
<span>Sub Total</span>
<b>₹ {subTotal.toFixed(2)}</b>
</div>

<div
style={{
display:"flex",
justifyContent:"space-between",
marginTop:10
}}
>
<span>GST Total</span>
<b>₹ {gstTotal.toFixed(2)}</b>
</div>

<hr/>

<div
style={{
display:"flex",
justifyContent:"space-between",
fontWeight:"bold",
fontSize:18
}}
>
<span>Grand Total</span>
<span>₹ {grandTotal.toFixed(2)}</span>
</div>

</div>

{/* SUBMIT BUTTON */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "32px" }}>
          <button 
            onClick={handleSubmit} 
            disabled={isSubmitting}
            style={{
              ...btnStyle,
              opacity: isSubmitting ? 0.7 : 1,
              cursor: isSubmitting ? "not-allowed" : "pointer"
            }}
          >
            {isSubmitting ? "Submitting..." : "Submit Quotation"}
          </button>
               </div>

      </div>
    </div>
  );
}

/* STYLES */
const containerStyle = {
  minHeight: "100vh",
  backgroundColor: "#f1f5f9",
  padding: "50px 20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  fontFamily: "'Inter', system-ui, -apple-system,0000000 sans-serif",
  boxSizing: "border-box"
};

const cardWrapperStyle = {
  width: "100%",
  maxWidth: "1440px",
  background: "#ffffff",
  borderRadius: "16px",
  boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05)",
  padding: "40px",
  boxSizing: "border-box"
};
const fileInputLabelStyle = {
  display: "inline-flex",
  alignItems: "center",
  padding: "8px 12px",
  backgroundColor: "#eff6ff",
  color: "#2563eb",
  borderRadius: "6px",
  fontSize: "12px",
  fontWeight: "600",
  cursor: "pointer",
  border: "1px dashed #bfdbfe",
  transition: "all 0.2s"
};

const headerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  marginBottom: "35px",
  borderBottom: "1px solid #f1f5f9",
  paddingBottom: "24px"
};

const tableContainerStyle = {
  background: "#fff",
  border: "1px solid #e2e8f0",
  borderRadius: "12px",
  overflowX: "auto"
};

const tableStyle = {
  width: "100%",
  minWidth: "1180px",
  borderCollapse: "collapse",
  tableLayout: "auto"
};

const thStyle = { 
  padding: "14px 20px", 
  textAlign: "left", 
  fontSize: "12px", 
  color: "#475569", 
  textTransform: "uppercase",
  fontWeight: "600",
  letterSpacing: "0.05em"
};

const tdStyle = { 
  padding: "16px 12px",
  color: "#334155",
  fontSize: "14px",
  verticalAlign: "middle",
  minWidth: "80px",
  overflowWrap: "anywhere"
};
const itemNameCellStyle = {
  minWidth: "220px",
  maxWidth: "420px",
  fontWeight: 600,
  lineHeight: 1.5,
  whiteSpace: "normal"
};
const amountCellStyle = {
  textAlign: "right",
  fontWeight: 700,
  whiteSpace: "nowrap"
};
const inputStyle = {
  width: "100%",
  padding: "10px", // Increased padding for better usability
  border: "1px solid #cbd5e1",
  borderRadius: "8px", // Smoother corners
  fontSize: "14px",
  outline: "none",
  backgroundColor: "#ffffff", // Changed from #f8fafc to pop more against the row
  transition: "border-color 0.2s"
};
const attachmentNameStyle = {
  display: "block",
  marginTop: 6,
  color: "#16a34a",
  fontSize: "11px",
  lineHeight: 1.35,
  overflowWrap: "anywhere"
};
const attachmentHintStyle = {
  display: "block",
  marginTop: 6,
  color: "#94a3b8",
  fontSize: "11px"
};

const btnStyle = {
  padding: "14px 32px",
  background: "#0f172a",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontWeight: "600",
  fontSize: "15px",
  transition: "background-color 0.2s ease, transform 0.1s ease",
  boxShadow: "0 4px 6px -1px rgba(15, 23, 42, 0.15)"
};

const centerStyle = { 
  display: "flex", 
  flexDirection: "column",
  gap: "12px",
  justifyContent: "center", 
  alignItems: "center", 
  height: "100vh",
  backgroundColor: "#f1f5f9",
  fontFamily: "'Inter', sans-serif",
  color: "#475569"
};

const spinnerStyle = {
  width: "24px",
  height: "24px",
  border: "3px solid #cbd5e1",
  borderTop: "3px solid #0f172a",
  borderRadius: "50%",
  animation: "spin 1s linear infinite"
};

const errorCardStyle = {
  background: "#fef2f2",
  color: "#991b1b",
  padding: "20px 30px",
  borderRadius: "12px",
  border: "1px solid #fee2e2",
  boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)"
};

export default VendorRFQPage;
